export function getFileNameWithoutExtension(fileName: string): string {
  return fileName.substring(0, fileName.lastIndexOf('.'));
}

export function getFileNameFromPath(fileName: string): string {
  const start = fileName.lastIndexOf('/') >= 0 ? fileName.lastIndexOf('/') + 1 : 0;
  return fileName.substring(start);
}
